import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    isUnarchiving?: boolean;
};

const UnarchiveChargeModal = ({ open, isUnarchiving, onConfirm, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={500}
            open={open}
            icon={<ContainerOutlined />}
            title="Unarchive Additional Charge"
            confirmButtonText="Unarchive"
            confirmationButtonLoading={isUnarchiving}
            onCancel={onClose}
            onConfirm={onConfirm}
            content={<Typography.Text>The additional charge will become active.</Typography.Text>}
        />
    );
};

export default UnarchiveChargeModal;
